import React, { useEffect, useState } from 'react'
import './index.less'
import { getQuery } from '@/server'
import { annotations, audios, images, videos } from '@/assets/images'
import { useAppSelector } from '@/hooks'

const class2attr = {
  annotations: {
    image: annotations,
    CNname: '标注',
    unit: 'MB',
    unitSize: 1 << 20
  },
  videos: {
    image: videos,
    CNname: '视频',
    unit: 'GB',
    unitSize: 1 << 30
  },
  images: {
    image: images,
    CNname: '图片',
    unit: 'GB',
    unitSize: 1 << 30
  },
  audios: {
    image: audios,
    CNname: '音频',
    unit: 'MB',
    unitSize: 1 << 20
  }
}
export function AssetDistribution() {
  const token = useAppSelector((state) => state.login.token)
  const [assetData, setAssetData] = useState<any>([])
  useEffect(() => {
    getQuery(
      {
        query: 'minio_bucket_usage_total_bytes',
        time: new Date()
      },
      token
    )
      .then((res) => {
        setAssetData(
          res.data.data.result.map((d) => {
            return { key: d['metric']['bucket'], value: d['value'][1] }
          })
        )
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <>
      <div className='asset-attribution-container'>
        {assetData.map((d) => (
          <div className='assetitem-container'>
            <div className='assetitem-title'>{class2attr[d.key].CNname}</div>
            <div className='split-line'></div>
            <div className='assetitem-content'>
              <div className='icon-container'>
                <img
                  src={class2attr[d.key].image}
                  alt=''
                  style={{ width: '48px', fill: '#997e6c' }}
                />
              </div>
              <div className='assetitem-usage'>
                {(Number(d.value) / class2attr[d.key].unitSize).toFixed(1)}
                <span className='assetitem-usage-unit'>{class2attr[d.key].unit}</span>
              </div>
              {d.key === 'annotations' ? (
                <div className='usage-details'>
                  <div className='detail-item'>
                    第一阶段 全局标签：<span className='item-number'>58599</span>
                  </div>
                  <div className='detail-item'>
                    第二阶段 全局标签：<span className='item-number'>107602</span>
                  </div>
                  <div className='detail-item'>
                    第三阶段 全局标签：<span className='item-number'>20476</span> 局部标签：
                    <span className='item-number'>75252</span>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
